import React, { Component } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import { countries } from "./countries";
import { make_request, after_auth } from "../../Utils/Utils";

const register_recaptcha_ref = React.createRef();
const USER_SOURCES = [ "Twitter",  "Facebook", "Instagram",  "Google",  "News",  "Office Colleague",  "Friend",  "Other"];
class Registration extends Component {
  constructor(props) {
    super(props);
    this.state = {
      submitted: false,
      user: {
        name: "",
        password: "",
        password_confirmation: "",
        email: "",
        display_name: "",
        mobile: "",
        date_of_birth: "",
        country: "",
        city: "",
        user_source: "",
        organization: ""
      },
      nameError: "",
      display_nameError: "",
      organizationError: "",
      emailError: "",
      mobilenumError: "",
      dobError: "",
      passwordError: "",
      cpasswordError: "",
      api_errors: false,
      api_error_message: "",
      usrname: false,
    };
  }

  validate = () => {
    let nameError = "";
    let emailError = "";
    let display_nameError = "";
    let mobilenumError = "";
    let dobError = "";
    let passwordError = "";
    let cpasswordError = "";
    let organizationError = "";

    /*NAME ERRORS*/
    if (!this.state.user.name) {
      nameError = "Name cannot be blank";
    } else {
      this.setState({ nameError: "" });
    }

    if (!this.state.user.name.match(/^[a-zA-Z ]*$/)) {
      nameError = "Enter correct name";
    } else {
      this.setState({ nameError: "" });
    }

    if (!this.state.user.display_name) {
      display_nameError = "Display name cannot be blank";
    } else {
      this.setState({ display_nameError: "" });
    }

    if (!this.state.user.organization) {
      organizationError = "Company/Organization cannot be blank";
    } else {
      this.setState({ organizationError: "" });
    }

    // if (!this.state.user.display_name.match(/^[a-zA-Z 1-9]*$/)) {
    //   display_nameError = "Enter correct display name";
    // } else {
    //   this.setState({ display_nameError: "" });
    // }

    /*EMAIL ERRORS*/

    if (!this.state.user.email.includes("@")) {
      emailError = "invalid email";
    } else {
      this.setState({ emailError: "" });
    }

    if (!this.state.user.email) {
      emailError = "Email cannot be blank";
    } else {
      this.setState({ emailError: "" });
    }

    /*MOBILE NUMBER ERROR*/

    if (!this.state.user.mobile.match(/^[0-9]*$/)) {
      mobilenumError = "Enter correct number";
    } else {
      this.setState({ mobilenumError: "" });
    }

    if (!this.state.user.mobile) {
      mobilenumError = "Mobile number cannot be blank";
    } else {
      this.setState({ mobilenumError: "" });
    }

    /*DOB ERROR*/

    if (!this.state.user.date_of_birth) {
      dobError = "Date of birth cannot be blank";
    } else {
      this.setState({ dobError: "" });
    }

    /*PASSWORD ERROR*/

    if (!this.state.user.password) {
      passwordError = "Password cannot be blank";
    } else {
      this.setState({ passwordError: "" });
    }

    if (this.state.user.password !== this.state.user.password_confirmation) {
      cpasswordError = "Passwords do not match";
    } else {
      this.setState({ cpasswordError: "" });
    }

    if (!this.state.user.password_confirmation) {
      cpasswordError = "Enter password confirmation";
    } else {
      this.setState({ cpasswordError: "" });
    }

    /* PRINTING ERRORS */

    if (
      emailError ||
      nameError ||
      display_nameError ||
      organizationError ||
      mobilenumError ||
      passwordError ||
      cpasswordError ||
      dobError
    ) {
      this.setState({
        emailError,
        nameError,
        display_nameError,
        organizationError,
        mobilenumError,
        passwordError,
        cpasswordError,
        dobError,
      });
      return false;
    }

    return true;
  };

  handle_change = (event) => {
    const { name, value } = event.target;
    const { user } = this.state;
    this.setState({
      user: {
        ...user,
        [name]: value,
      },
    });
  };

  resetCaptcha = () => {
    register_recaptcha_ref.current.reset();
  };

  onFormSubmit = async (event) => {
    event.preventDefault();
    const recaptcha_response = await register_recaptcha_ref.current.executeAsync();
    if (!!recaptcha_response) {
      const isValid = this.validate();
      this.setState({ submitted: true });
      const { user } = this.state;
      if (!isValid) {
        this.setState({ submitted: false });
        return;
      }
      let responseJson = await make_request({
        path: "auth",
        method: "POST",
        body: Object.assign(user, {
          confirm_success_url: process.env.REACT_APP_DOMAIN+"/login",
          recaptcha_response: recaptcha_response
        }),
      });
      if (responseJson) {
        if (responseJson.status === "success") {
          // after_auth(responseJson);
          return window.location = "/login?source=registration"
        } else {
          // console.log("responseJson => "+JSON.stringify(responseJson))

          let json_string = JSON.parse(responseJson["message"]["responseText"]);
          let api_errors = json_string["errors"]["full_messages"];
          let errorItems = api_errors.map((error) => (
            <li key="error">{error}</li>
          ));
          this.setState({ api_errors: true });
          this.setState({ api_error_message: errorItems });
          this.setState({ submitted: false });
        }
      } else {
        this.setState({ submitted: false });
      }
    }
  };

  render() {
    return (
      <form
        onSubmit={this.onFormSubmit}
        id="register"
        className="needs-validation"
      >
        <div className="row">
          <div className="col-md-6 col-12">
            <input
              type="text"
              className="form-control"
              placeholder="Name *"
              id="name"
              value={this.state.user.name}
              onChange={this.handle_change}
              name="name"
              autoFocus={true}
            />
            <div className="errmsg">{this.state.nameError}</div>
          </div>
          <div className="col-md-6 col-12">
            <input
              type="text"
              className="form-control"
              placeholder="Display Name *"
              id="display_name"
              value={this.state.user.display_name}
              onChange={this.handle_change}
              name="display_name"
            />
            <div className="errmsg">{this.state.display_nameError}</div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6 col-12">
            <input
              type="email"
              className="form-control"
              placeholder="Email Address *"
              id="email"
              value={this.state.user.email}
              onChange={this.handle_change}
              name="email"
            />
            <div className="errmsg">{this.state.emailError}</div>
          </div>
          <div className="col-md-6 col-12">
            <input
              type="number"
              className="form-control"
              placeholder="Mobile *"
              id="mobile"
              value={this.state.user.mobile}
              onChange={this.handle_change}
              name="mobile"
            />
            <div className="errmsg">{this.state.mobilenumError}</div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6 col-12">
            <input
              type="date"
              className="form-control "
              placeholder="Date of birth *"
              id="date_of_birth"
              value={this.state.user.date_of_birth}
              onChange={this.handle_change}
              name="date_of_birth"
            />
            <div className="errmsg">{this.state.dobError}</div>
          </div>

          <div className="col-md-6 col-12">
            {countries(this.state, this.handle_change)}
          </div>
        </div>

        <div className="row">
          <div className="col-md-6 col-12">
            <input
              type="password"
              className="form-control"
              placeholder="Password *"
              id="password"
              value={this.state.user.password}
              onChange={this.handle_change}
              name="password"
              autoComplete="new-password"
            />
            <div className="errmsg">{this.state.passwordError}</div>
          </div>
          <div className="col-md-6 col-12">
            <input
              type="password"
              className="form-control"
              placeholder="Confirm Password *"
              id="password_confirmation"
              value={this.state.user.password_confirmation}
              onChange={this.handle_change}
              name="password_confirmation"
            />
            <div className="errmsg">{this.state.cpasswordError}</div>
          </div>
        </div>

        <div className="row">
          <div className="col-md-6 col-12">
            <select
              id="user_source"
              name="user_source"
              className="form-control"
              value={this.state.user.user_source}
              onChange={this.handle_change}
              style={{width:"96%"}}
            >
              <option value="" disabled>
                Where did you hear about us?
              </option>
              {
                USER_SOURCES.map(option =>
                  <option value={option} key={option}>{option}</option>
                  )
              }
            </select>
          </div>
          <div className="col-md-6 col-12">
            <input
              type="text"
              className="form-control"
              placeholder="Company/Organization *"
              id="organization"
              value={this.state.user.organization}
              onChange={this.handle_change}
              name="organization"
            />
            <div className="errmsg">{this.state.organizationError}</div>
          </div>
        </div>

        <div className="wrong_txt mb-2 mt-4 text-center">
          {this.state.api_errors && (
            <div>
              {" "}
              <ul> {this.state.api_error_message}</ul>{" "}
            </div>
          )}
        </div>

        <div className="">
          <ReCAPTCHA
            ref={register_recaptcha_ref}
            size="invisible"
            sitekey={process.env.REACT_APP_GOOGLE_SITE_KEY}
            onChange={this.resetCaptcha}
          />
          <button
            id="register_btn"
            type="button"
            className="btn btn-yellow g-recaptcha"
            onClick={this.onFormSubmit}
            data-sitekey="6Ldgu-YUAAAAAPvAxfe06gmGLSOvk-bBto6oE_hf"
            disabled={this.state.submitted}
            style={{ width: "97%" }}
          >
            REGISTER
          </button>
        </div>
      </form>
    );
  }
}

export default Registration;
